@use "variables" as *;

.toolbarButton {
  height: fit-content !important;
  align-self: center !important;
  flex-shrink: 0 !important;
}

.loadingIndicator {
  width: $fontSize-l !important;
  height: $fontSize-l !important;
}
